module.exports = __webpack_public_path__ + "img/bxs-check-circle.ebe6b80f.svg";